module.exports = __webpack_public_path__ + "img/fu.4fa76aaa.png";